import React, { ReactNode, useEffect, VFC } from 'react';
import { useHistory } from 'react-router-dom';

const { match } = require('path-to-regexp');

interface Props {
  reactRouterLinks: string[];
  children: ReactNode;
}
const HandleTurbolinks: VFC<Props> = ({
  reactRouterLinks,
  children,
}: Props) => {
  const history = useHistory();

  useEffect(() => {
    return history.listen(({ pathname }, action) => {
      const isReactRouterLink = reactRouterLinks.some((link) => {
        const matchFunc = match(link);
        return matchFunc(pathname);
      });

      if (action === 'POP' && !isReactRouterLink) {
        window.location = pathname as any;
      }
    });
  }, [reactRouterLinks, history]);
  return <>{children}</>;
};

export default HandleTurbolinks;
